import type { CreateElementClickEventData } from '../types/index.js';

export const createElementClickEventData: CreateElementClickEventData = (
  data,
) => ({
  action: 'Click',
  object: {
    type: 'UIElement',
    elementType: 'Button',
    ...data.object,
    page: {
      ...data.object.page,
      url: window.location.href,
    },
  },
  target: data?.target
    ? {
        id: data.target?.id,
        type: data.target?.type,
        name: data.target?.name,
        accessLevel: data.target?.accessLevel,
        accessLevelName: data.target?.accessLevelName,
        ...data?.target,
      }
    : undefined,
});
